import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CreateKeyword from './KeywordAudit/KeywordAudit';
import Header from '../../Components/Header/Header';
class KeywordAuditTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='CK-pages'>
        <div className='right-section'>
          <div className='parentTable'>
            <Header page='Keyword Audit' />
            <CreateKeyword />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userLogin } = state;
  const {
    keywordList,
    keywordAudit,
    loading,
    success,
    error,
  } = state.CreatorDashboardReducer;

  return {
    keywordList,
    keywordAudit,
    loading,
    userLogin,
    success,
    error,
  };
}

export default withRouter(connect(mapStateToProps, {})(KeywordAuditTeam));
